function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.177 51.963c3.316-2.113 5.016-4.717 5.1-7.812.085-3.095-1.46-5.652-4.634-7.67L45.331 17.74l28.274 19.04v28.924H17.177V51.963zm9.589-10.604V60.98h11.433V41.36H26.766z",
  fill: "#A1887F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.677 52.282v12.922h55.428V37.047L45.333 18.343 18.944 36.266c2.982 3.13 4.208 6.263 3.628 9.379-.582 3.122-2.222 5.349-4.895 6.637z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.209 36.863L45.392 13.987 15.718 34.378c.765.273 1.328.545 1.699.823.381.287.977.624 1.78 1.007l26.054-17.81 30 20.19 2.958-1.725zm-35.084 2.815h22.932V55.03H43.125zm-15.859 2.181H37.7v18.622H27.266zm15.359 20.757h25.448m-50.159 0h6.482m14.909-20.894H25.66v-3.697h13.646",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  d: "M26.16 60.39h12.645v4.304H26.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.474 20.193l.003-.997-1 .997h.997zm0 0h5.315l.665-1h-6.977l-.03 10.538 1.004-1.51.023-8.028zm-.997 0l1-.997-.003.997h-.997zm.997 0h5.315l.665-1h-6.977l-.03 10.538 1.004-1.51.023-8.028z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.07 34.581)",
  stroke: "#371447"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.886,
  cy: 9.431,
  rx: 9.535,
  ry: 9.431
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.056 31.123V6.941m-.338 6.63l-3.684-1.656m7.034-3.312l-3.35 2.65"
})), /*#__PURE__*/React.createElement("path", {
  d: "M58.852 20.642c.376-.891 1.275-.84 1.542-.84.401 0 .78.093 1.114.26.377-2.346 2.458-4.14 4.967-4.14 1.96 0 3.657 1.093 4.487 2.688a4.029 4.029 0 012.179-.634c2.196 0 3.976 1.737 3.976 3.879-.022 1.006-.475 1.788-1.357 2.347-2.732-.02-6.07-.042-10.013-.068M7.246 65.463h70.465",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.67 42.765l-5.545 4.929m11.663-5.309l-5.544 4.93m5.926 0l-5.544 4.929",
  stroke: "#371447",
  strokeLinecap: "square"
}));

function SvgHomeLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHomeLg;